import kr from 'Kr/kr';
import HTMLClass from 'Kr/utils/HTMLClass';

export default class BuyRotator extends kr.Module
{
    init() {
        this.alert = null;
        this.messages = window.rotator;
        this.interval;
        this.bind();
    }

    bind() {
        let intervalTimeout = this.randomIntFromInterval(15000, 120000);
        console.log(intervalTimeout);
        setTimeout(() => {
            this.showAlert();
            this.bind();
        }, intervalTimeout);
    }

    showAlert()
    {
        const randMessage = this.randomIntFromInterval(1,3);
        const message = this.messages[randMessage];
        this.alert = document.createElement('div');
        HTMLClass.addClass(this.alert, 'alert');
        this.alert.innerHTML = `
        <div class="alert__content">
        ${message}
        </div>
        `;
        this.app.dom.$body.appendChild(this.alert);
        this.alert.addEventListener('click', () => {
            this.closeAlert();
        });
        setTimeout(() => {
            HTMLClass.addClass(this.alert, 'alert--visible');
        }, 50);
        setTimeout(() => {
            this.closeAlert();
        }, 8000);
    }

    closeAlert()
    {
        if (this.alert === null) {
            return;
        }

        HTMLClass.removeClass(this.alert, 'alert--visible');
        setTimeout(() => {
            this.app.dom.$body.removeChild(this.alert);
            this.alert = null;
        }, 210);
    }

    randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }
}